import React from "react";
import styles from "./Product.module.scss";

function Product(props) {
	return (
		<div className={styles.Product}>
			<h1>PRODUCT</h1>
		</div>
	);
}

export default Product;
